{
  "addressForm": {
    "actions": {
      "cancel": "Annuler",
      "create": "Créer l'adresse",
      "saveChanges": "Enregistrer les modifications",
      "saving": "Enregistrement…"
    },
    "dialog": {
      "createSubtitle": "Saisissez les informations d'adresse. Vous pourrez l'affecter à une boutique après sa création.",
      "createTitle": "Ajouter une adresse de facturation",
      "editSubtitle": "Remarque : les modifications ne s'appliquent qu'aux factures générées par la suite. Les anciennes factures conservent leur instantané.",
      "editTitle": "Modifier l'adresse de facturation"
    },
    "errors": {
      "createFailed": "Échec de la création de l'adresse (HTTP {{status}}).",
      "loadFailed": "Échec du chargement de l'adresse (HTTP {{status}}).",
      "noData": "La réponse ne contient aucune donnée d'adresse.",
      "staleRecord": "Cet enregistrement a été mis à jour ailleurs. Rouvrez l'adresse pour obtenir les données les plus récentes.",
      "unknown": "Erreur inconnue. Veuillez réessayer.",
      "updateFailed": "Échec de la mise à jour (HTTP {{status}})."
    },
    "fields": {
      "address": "Adresse *",
      "businessName": "Nom de l'entreprise",
      "city": "Ville",
      "country": "Pays (ISO 2 lettres)",
      "email": "E-mail *",
      "name": "Nom du destinataire *",
      "phone": "Téléphone",
      "state": "État/Province",
      "taxId": "N° fiscal",
      "zip": "Code postal"
    },
    "loading": "Chargement de l'adresse…",
    "placeholders": {
      "address": "123 Le Loi Street, District 1",
      "country": "VN, US, JP…"
    },
    "toast": {
      "createFailedTitle": "Échec de la création de l'adresse",
      "createdDesc": "Vous pouvez affecter cette adresse à une boutique depuis la liste.",
      "createdTitle": "Adresse de facturation ajoutée",
      "updateFailedTitle": "Échec de la mise à jour",
      "updatedDesc": "Les modifications s'appliquent uniquement aux nouvelles factures — les anciennes factures restent inchangées.",
      "updatedTitle": "Adresse mise à jour"
    },
    "validation": {
      "addressMax": "Adresse ≤ 500 caractères.",
      "addressRequired": "L'adresse est obligatoire.",
      "businessNameMax": "Nom de l'entreprise ≤ 200 caractères.",
      "cityMax": "Ville ≤ 100 caractères.",
      "countryInvalid": "Le pays doit être un code ISO de 2 lettres majuscules (ex. : VN, US).",
      "emailInvalid": "E-mail invalide.",
      "emailMax": "E-mail ≤ 254 caractères.",
      "emailRequired": "L'e-mail est obligatoire.",
      "nameMax": "Nom ≤ 200 caractères.",
      "nameRequired": "Le nom du destinataire est obligatoire.",
      "phoneMax": "Téléphone ≤ 30 caractères.",
      "stateMax": "État/Province ≤ 100 caractères.",
      "taxIdMax": "N° fiscal ≤ 50 caractères.",
      "zipMax": "Code postal ≤ 20 caractères."
    }
  },
  "addresses": {
    "actions": {
      "assignStores": "Affecter des boutiques",
      "cancel": "Annuler",
      "create": "+ Ajouter une adresse",
      "delete": "Supprimer",
      "edit": "Modifier",
      "retry": "Réessayer"
    },
    "confirmDelete": {
      "deleting": "Suppression…",
      "description": "Supprimer « {{name}} » ? Si elle est affectée à une boutique, le système la bloquera (HTTP 409). Les anciennes factures conservent leur instantané — elles ne sont pas affectées.",
      "title": "Supprimer l'adresse de facturation ?"
    },
    "empty": {
      "createButton": "+ Ajouter votre première adresse",
      "description": "Ajoutez votre première adresse à imprimer sur les factures. Vous pouvez créer plusieurs adresses et les affecter à des boutiques individuelles.",
      "title": "Aucune adresse de facturation pour l'instant"
    },
    "errors": {
      "deleteAssigned": "Suppression impossible : l'adresse est affectée à une ou plusieurs boutiques.",
      "deleteFailed": "Échec de la suppression (HTTP {{status}}).",
      "listFailed": "Échec du chargement de la liste (HTTP {{status}}).",
      "listGeneric": "Erreur lors du chargement de la liste.",
      "loadAddressFailed": "Échec du chargement de l'adresse (HTTP {{status}}).",
      "unknown": "Erreur inconnue. Veuillez réessayer."
    },
    "header": {
      "subtitle": "Gérez les adresses imprimées sur les factures. Une adresse peut être affectée à plusieurs boutiques ; les boutiques non affectées utilisent l'adresse par défaut.",
      "title": "Adresses de facturation"
    },
    "pagination": {
      "first": "Première page",
      "last": "Dernière page",
      "navLabel": "Pagination",
      "next": "Page suivante",
      "pageN": "Page {{page}}",
      "prev": "Page précédente",
      "summary": "Affichage de {{from}}–{{to}} sur {{total}} enregistrements · Page {{page}} / {{totalPages}}"
    },
    "sort": {
      "country": "Par pays",
      "newest": "Plus récentes",
      "oldest": "Plus anciennes"
    },
    "table": {
      "actions": "Actions",
      "address": "Adresse",
      "assignedStores": "Boutiques affectées",
      "business": "Entreprise",
      "cannotDeleteDefault": "Impossible de supprimer l'adresse par défaut",
      "default": "Par défaut",
      "defaultBadge": "Par défaut",
      "recipient": "Destinataire",
      "taxId": "N° fiscal : {{taxId}}"
    },
    "toast": {
      "deleteFailedTitle": "Échec de la suppression",
      "deletedTitle": "Adresse de facturation supprimée"
    },
    "toolbar": {
      "sortLabel": "Trier"
    }
  },
  "alerts": {
    "card": {
      "description": "Le système envoie une alerte lorsque le solde du portefeuille passe sous le seuil. La même valeur de seuil est utilisée pour la recharge automatique (auto-recharge — Task 20). Le canal in-app (cloche + Centre de notifications) est toujours activé conformément à la politique P3.D-11.",
      "title": "Alerte de solde faible (Low-Balance Alert)"
    },
    "channelLabels": {
      "email": "E-mail",
      "inApp": "In-app",
      "inAppForced": "In-app (forcé)",
      "push": "Push"
    },
    "channels": {
      "emailHint": "Envoie l'alerte à l'e-mail enregistré du compte propriétaire. Activé par défaut.",
      "emailTitle": "E-mail",
      "forcedWarning": "Remarque : même si les 3 canaux sont désactivés, in-app est toujours envoyé (forcé côté serveur).",
      "inAppHint": "In-app est toujours activé (obligatoire selon la politique P3.D-11) — il ne peut pas être désactivé.",
      "inAppTitle": "In-app (cloche + Centre de notifications)",
      "legend": "Canaux de notification",
      "pushHint": "Nécessite l'autorisation de notification du navigateur. Activé par défaut.",
      "pushTitle": "Push (notification push du navigateur)"
    },
    "errors": {
      "saveFailed": "Échec de l'enregistrement des paramètres d'alerte.",
      "saveFailedRetry": "Impossible d'enregistrer les paramètres d'alerte. Veuillez réessayer.",
      "testFailed": "Échec de l'envoi de l'alerte de test.",
      "testRateLimited": "Alerte de test envoyée trop rapidement. Veuillez patienter 1 minute puis réessayer.",
      "testSuspended": "Le compte est suspendu. Impossible d'envoyer une alerte de test.",
      "testThresholdNotConfigured": "Configurez un seuil de solde (seuil > 0) avant d'envoyer une alerte de test."
    },
    "form": {
      "saveButton": "Enregistrer les paramètres",
      "saving": "Enregistrement…",
      "sendTestButton": "Envoyer une alerte de test (1 / minute)",
      "sendingTest": "Envoi…",
      "testDisabledHint": "Configurez un seuil de solde avant d'envoyer une alerte de test.",
      "thresholdHelp": "Lorsque le solde passe sous le seuil (vers le bas) → une alerte est envoyée. Après une recharge au-dessus puis une nouvelle baisse → une autre alerte est envoyée. Laisser vide = utiliser le seuil par défaut du système ({{state}}).",
      "thresholdLabel": "Seuil d'alerte (USD)",
      "thresholdPlaceholderEnvDefault": "Utilise la valeur par défaut du système",
      "thresholdPlaceholderExample": "ex. : 50",
      "thresholdStateApplying": "actuellement appliqué",
      "thresholdStateOverride": "sera remplacé"
    },
    "suspended": {
      "readOnlyNotice": "Le compte est suspendu. Tous les paramètres sont en lecture seule."
    },
    "toast": {
      "rateLimitedTitle": "Limite dépassée (1/minute)",
      "saveFailedTitle": "Échec de l'enregistrement",
      "savedDesc": "Les paramètres d'alerte de solde ont été mis à jour.",
      "savedTitle": "Enregistré",
      "testFailedTitle": "Échec de l'envoi de l'alerte de test",
      "testSentDesc": "Canaux envoyés : {{channels}}.",
      "testSentTitle": "Alerte de test envoyée"
    },
    "validation": {
      "thresholdNonNegative": "Le seuil d'alerte (solde minimum) doit être un nombre non négatif."
    }
  },
  "assignStores": {
    "assigned": {
      "empty": "Aucune boutique pour l'instant — les boutiques non attribuées reviennent à l'adresse par défaut.",
      "heading": "Boutiques actuellement attribuées ({{count}})"
    },
    "buttons": {
      "cancel": "Annuler",
      "submit": "Attribuer {{count}} boutiques",
      "submitting": "Attribution…"
    },
    "counts": {
      "invalid": "Non valides : {{count}}",
      "max": "Max : 50",
      "valid": "Valides : {{count}}"
    },
    "errors": {
      "assignFailedHttp": "Échec de l'attribution des boutiques (HTTP {{status}}).",
      "invalidIds": "{{count}} identifiant(s) non valide(s). Un ID doit être un UUID ou un hex de 24 caractères (ObjectId).",
      "maxFifty": "Vous pouvez attribuer au maximum 50 boutiques à la fois.",
      "minOne": "Veuillez saisir au moins 1 identifiant de boutique valide.",
      "noAddress": "Adresse de facturation introuvable.",
      "unknown": "Erreur inconnue. Veuillez réessayer."
    },
    "fallbackNote": "Les boutiques omises reviennent à l'adresse par défaut.",
    "input": {
      "label": "Identifiants de boutique (UUID ou hex 24 caractères, un ID par ligne ou séparés par des virgules)"
    },
    "replaceNote": "La soumission remplacera l'intégralité de l'attribution pour cette adresse (sémantique de remplacement).",
    "subtitle": {
      "default": "Choisissez les boutiques qui utiliseront cette adresse sur les factures.",
      "withLabel": "Adresse : {{label}}"
    },
    "title": "Attribuer des boutiques à l'adresse de facturation",
    "toast": {
      "errorTitle": "Échec de l'attribution des boutiques",
      "successDescription": "Les boutiques sont désormais attribuées à cette adresse de facturation.",
      "successTitle": "Attribution mise à jour"
    }
  },
  "autoPay": {
    "card": {
      "description": "Configurez le débit automatique du portefeuille lors de la création d'une commande. S'applique aux commandes, aux surcharges (surcharge — frais supplémentaires ajoutés par un admin), aux frais de numérisation de broderie (digitize fee) et aux frais de broderie (embroidery fee). Lorsque désactivé, la commande est tout de même créée à l'état impayé (unpaid) et vous devez payer manuellement.",
      "title": "Paiement automatique (auto-pay)"
    },
    "errors": {
      "network": "Une erreur réseau s'est produite (network error — vérifiez votre connexion).",
      "persistence": "L'enregistrement n'a pas été confirmé par le serveur (persistence check failed — vérifiez les signes de ghost-save). Veuillez réessayer.",
      "suspended": "Votre compte est suspendu — impossible de mettre à jour la configuration du paiement automatique (auto-pay)."
    },
    "loadError": {
      "generic": "erreur inconnue",
      "label": "Impossible de charger la configuration actuelle : {{message}}"
    },
    "master": {
      "help": "Lorsqu'il est activé, le système débite automatiquement les fonds de la source sélectionnée ci-dessous dès la création d'une commande. Les commandes sans fonds suffisants passent à pending_payment et sont réessayées automatiquement (auto retry) lorsque le portefeuille dispose de plus de fonds.",
      "label": "Activer le paiement automatique"
    },
    "mode": {
      "legend": "Source de financement (funding source)",
      "rule": "Règle : une seule source doit couvrir la TOTALITÉ de la commande — le système ne fractionne pas les paiements (no split payment). Exemple : une commande de {{order}}, portefeuille {{wallet}} + crédit {{credit}} → la commande reste impayée car aucune source seule ne suffit.",
      "walletOnly": {
        "hint": "Débiter uniquement le portefeuille. Si le portefeuille est insuffisant → la commande reste impayée.",
        "label": "Portefeuille uniquement (wallet only)"
      },
      "walletPlusCredit": {
        "hint": "Essayer d'abord le portefeuille ; si le portefeuille ne couvre pas la TOTALITÉ de la commande, le système tente un débit sur le crédit (credit) — toujours selon la règle d'une source couvrant la totalité.",
        "label": "Portefeuille + Crédit (wallet + credit)"
      }
    },
    "notify": {
      "email": "E-mail",
      "help": "Désactivez si vous traitez de nombreuses commandes et souhaitez éviter le spam de notifications. Le système peut tout de même regrouper plusieurs commandes en une seule notification (notification batch) si nécessaire.",
      "inApp": "In-app (cloche de notification dans la TopBar)",
      "legend": "Notifier en cas de succès de l'auto-pay"
    },
    "submit": {
      "loading": "Chargement…",
      "save": "Enregistrer la configuration",
      "saving": "Enregistrement…",
      "suspendedTitle": "Compte suspendu — enregistrement impossible"
    },
    "success": "Configuration du paiement automatique enregistrée.",
    "suspendedBanner": "Votre compte est suspendu (suspended) — lecture seule, la configuration ne peut pas être modifiée."
  },
  "autoRecharge": {
    "actions": {
      "save": "Enregistrer les paramètres",
      "saving": "Enregistrement…"
    },
    "card": {
      "description": "Ajoute automatiquement des fonds à votre portefeuille lorsque le solde passe sous le seuil de déclenchement (solde minimum). S'applique aux commandes, surcharges, frais de numérisation et frais de broderie.",
      "title": "Recharge automatique"
    },
    "disabledBanner": "Le système a automatiquement désactivé la recharge automatique après plusieurs échecs consécutifs. Vérifiez votre moyen de paiement et réactivez-la manuellement.",
    "fields": {
      "amountHelp": "Doit être supérieur ou égal au seuil de déclenchement et d'au moins {{min}}.",
      "amountLabel": "Montant par recharge (USD)",
      "amountPlaceholder": "Minimum {{min}}",
      "enabledLabel": "Activer la recharge automatique",
      "maxPerDayHelp": "Configuré par un administrateur (admin). Dépasser la limite désactivera automatiquement la recharge automatique et enverra une notification.",
      "maxPerDayLabel": "Limite de recharge automatique quotidienne",
      "maxPerDayValue": "{{limit}} fois / jour",
      "methodDefaultSuffix": " (par défaut)",
      "methodLabel": "Moyen de paiement",
      "methodNone": "— Aucun sélectionné —",
      "thresholdHelp": "Lorsque le solde de votre portefeuille passe sous ce niveau, le système déclenche une recharge automatique. La même valeur est utilisée pour l'alerte de solde bas.",
      "thresholdLabel": "Seuil de déclenchement (USD)",
      "thresholdPlaceholder": "ex. 50"
    },
    "noMethod": {
      "linkText": "Moyens de paiement",
      "prefix": "Aucun moyen de paiement éligible pour le moment. Accédez à ",
      "suffix": " pour lier PayPal / Stripe / Payoneer / LianLian."
    },
    "toast": {
      "saveErrorDesc": "Impossible d'enregistrer les paramètres de recharge automatique. Veuillez réessayer.",
      "saveErrorTitle": "Échec de l'enregistrement",
      "saveSuccessDesc": "Les paramètres de recharge automatique ont été mis à jour.",
      "saveSuccessTitle": "Enregistré"
    },
    "toggle": {
      "disabledHint": "Désactivé — vous devez recharger manuellement lorsque le solde est bas.",
      "enabledHint": "Activé — le système rechargera automatiquement lorsque le solde passe sous le seuil.",
      "needMethodTooltip": "Vous devez lier un moyen de paiement prenant en charge le débit serveur à serveur (PayPal / Stripe / Payoneer / LianLian) avant d'activer la recharge automatique."
    },
    "validation": {
      "amountGteThreshold": "Le montant de la recharge (USD ajoutés à chaque fois) doit être supérieur ou égal au seuil de déclenchement.",
      "amountMin": "Le montant de la recharge doit être d'au moins {{min}} (minimum du système).",
      "needLinkedMethod": "Vous devez lier un moyen de paiement (un compte de passerelle vérifié) avant d'activer la recharge automatique.",
      "selectMethod": "Veuillez sélectionner un moyen de paiement pour la recharge automatique.",
      "thresholdPositive": "Le seuil de déclenchement (solde minimum) doit être supérieur à 0."
    }
  },
  "billingLayout": {
    "actions": {
      "generateReport": "Générer un rapport",
      "generateReportAria": "Générer un rapport de facturation",
      "topUp": "+ Recharger le portefeuille",
      "topUpAria": "Recharger le portefeuille"
    },
    "header": {
      "subtitle": "Gérez les factures, les recharges et les rapports d'exécution",
      "title": "Aperçu de la facturation"
    },
    "kpi": {
      "autoTopup": {
        "label": "Statut de la recharge automatique",
        "off": "Désactivé",
        "offHint": "Désactivé — activez pour recharger automatiquement",
        "on": "Activé",
        "onHint": "Lorsque le solde < {{threshold}} → recharger {{topup}}"
      },
      "balance": {
        "label": "Solde du portefeuille",
        "loading": "Chargement du portefeuille…",
        "pendingTopup": "Recharge en attente {{amount}}"
      },
      "pendingInvoices": {
        "label": "Factures en attente",
        "subLabel": "{{amount}} en attente de paiement"
      },
      "spending": {
        "label": "Dépenses ce mois-ci",
        "subLabel": "30 derniers jours (MTD)"
      }
    },
    "settingsPlaceholder": {
      "suffix": ".",
      "text": "Paramètres de facturation (auto-pay, auto-recharge, low balance alert, invoice schedule, billing addresses, payment methods, 2FA) — Wave 6 Task 17/18. Pour l'instant, accédez-y séparément sur "
    },
    "tabs": {
      "ariaLabel": "Sections de facturation",
      "settings": "Paramètres",
      "transactions": "Transactions"
    },
    "transactionsPlaceholder": {
      "suffix": ".",
      "text": "Historique détaillé des transactions — Wave 6 Task 17 (transactions table + filter chips + invoice action). Pour l'instant, consultez le portefeuille complet sur "
    },
    "walletError": "Échec du chargement du portefeuille ({{message}}).",
    "walletErrorUnknown": "inconnu"
  },
  "billingPage": {
    "description": "Suivez le crédit et la dette en cours. La Phase 3.5 ajoutera le portefeuille, les transactions et les relevés.",
    "title": "Facturation (aperçu financier)"
  },
  "creditCard": {
    "daysValue": "{{count}} j",
    "debt": {
      "current": "Dette actuelle : {{amount}}.",
      "none": "Aucune dette en cours à payer."
    },
    "fields": {
      "daysLeft": "Jours restants",
      "limit": "Plafond",
      "remaining": "Restant"
    },
    "payCta": "Payer la dette",
    "status": {
      "active": "Actif",
      "expired": "Expiré",
      "overdue": "En retard",
      "revoked": "Révoqué"
    },
    "title": "Crédit"
  },
  "invoiceDetail": {
    "actions": {
      "dispute": "Contester",
      "downloadPdf": "Télécharger le PDF",
      "downloadPdfAria": "Télécharger le PDF",
      "downloading": "Téléchargement…",
      "pay": "Payer {{amount}}"
    },
    "bank": {
      "accountHolder": "Titulaire du compte",
      "accountNumber": "Numéro de compte",
      "accountType": "Type de compte",
      "bankAddress": "Adresse de la banque",
      "bankCode": "Code banque",
      "bankName": "Nom de la banque",
      "branchCode": "Code agence",
      "heading": "Compte bancaire",
      "subtitle": "Détails du virement pour {{name}}.",
      "swiftCode": "Code SWIFT",
      "walletsHeading": "Autres portefeuilles acceptés"
    },
    "detailError": {
      "backToInvoices": "Retour aux factures",
      "loadFailed": "Échec du chargement de la facture",
      "retry": "Réessayer"
    },
    "download": {
      "failedHttp": "Échec du téléchargement du PDF (HTTP {{status}})",
      "failedTitle": "Échec du téléchargement",
      "networkError": "Erreur réseau - vérifiez la connexion",
      "notReady": "Facture encore en brouillon — PDF pas encore généré."
    },
    "gateway": {
      "airwallex": "Airwallex",
      "bank": "Virement bancaire",
      "lianlian": "LianLian",
      "manual": "Manuel",
      "payoneer": "Payoneer",
      "paypal": "PayPal",
      "pingpong": "PingPong",
      "stripe": "Stripe",
      "sunrate": "Sunrate",
      "worldfirst": "WorldFirst"
    },
    "header": {
      "backToInvoices": "Retour aux factures",
      "cycleLabel": "Cycle {{start}} → {{end}}",
      "netTerms": " · Conditions de paiement (échéance {{date}})",
      "title": "Facture {{number}}"
    },
    "help": {
      "contactSupport": "Contacter le support",
      "heading": "Besoin d'aide ?",
      "question": "Des questions sur cette facture ?"
    },
    "lineItems": {
      "colDescription": "Description",
      "colQty": "Qté",
      "colTotal": "Total",
      "colUnit": "Unité",
      "empty": "Aucune ligne.",
      "heading": "Lignes",
      "subtotal": "Sous-total",
      "tax": "Taxe",
      "totalDue": "Total dû"
    },
    "notFound": {
      "backToInvoices": "Retour aux factures",
      "message": "Facture introuvable."
    },
    "payDialog": {
      "ariaLabel": "Soumettre le paiement",
      "bodyAfter": "(Task 47, Wave 15). Cette boîte de dialogue héberge le test ID afin que le flux de paiement reste accessible pendant le branchement du composant canonique.",
      "bodyBefore": "Le formulaire complet de soumission de paiement (passerelle, montant, référence, téléversement du justificatif, notes) est fourni par le composant partagé",
      "cancel": "Annuler",
      "close": "Fermer",
      "submit": "Continuer vers le paiement",
      "subtitle": "Facture {{number}} · Restant {{amount}}",
      "title": "Soumettre le paiement"
    },
    "payment": {
      "dueLabel": "Échéance :",
      "heading": "Paiement",
      "paidLabel": "Payé :",
      "payNow": "Payer maintenant",
      "payNowAria": "Payer maintenant"
    },
    "paymentStatus": {
      "APPROVED": "Approuvé",
      "PENDING_APPROVAL": "En attente d'approbation",
      "REJECTED": "Rejeté",
      "REVERSED": "Annulé"
    },
    "payments": {
      "colAmount": "Montant",
      "colGateway": "Passerelle",
      "colReference": "Référence",
      "colStatus": "Statut",
      "colSubmitted": "Soumis",
      "heading": "Historique des paiements"
    },
    "preview": {
      "heading": "Aperçu de la facture",
      "iframeTitle": "Aperçu de la facture {{number}}",
      "subtitle": "Généré à partir du modèle PDF le plus récent."
    },
    "status": {
      "DRAFT": "Brouillon",
      "OVERDUE": "En retard",
      "PAID": "Payée",
      "PARTIAL": "Partiellement payée",
      "PENDING_APPROVAL": "En attente d'approbation",
      "SENT": "En attente de paiement",
      "VOIDED": "Annulée"
    }
  },
  "invoiceList": {
    "errors": {
      "loadTitle": "Échec du chargement des factures",
      "unknown": "Erreur inconnue"
    },
    "filters": {
      "dueBeforeAria": "Échéance avant la date",
      "searchAria": "Rechercher des factures par numéro ou mois",
      "searchPlaceholder": "N° de facture ou mois…",
      "statusAria": "Filtrer par statut"
    },
    "forbidden": {
      "backHome": "Retour à l'accueil",
      "body": "La page Factures est accessible uniquement au propriétaire du marchand. Si vous devez consulter les factures, veuillez contacter le propriétaire pour demander un changement de scope ou l'autorisation appropriée (TS-34).",
      "title": "Propriétaire uniquement"
    },
    "header": {
      "subtitle": "Cycles de facturation passés et actuels. Les factures Net-Terms sont émises automatiquement selon le cycle configuré par le marchand.",
      "title": "Mes factures"
    },
    "pagination": {
      "next": "Suivant",
      "prev": "Précédent",
      "summary": "Affichage {{from}}–{{to}} sur {{total}} factures · Page {{page}} / {{totalPages}}"
    },
    "payDisabled": {
      "DRAFT": "Facture brouillon",
      "PAID": "Déjà payée",
      "PENDING_APPROVAL": "En attente d'approbation admin",
      "VOIDED": "Facture annulée",
      "default": "Paiement impossible"
    },
    "payModal": {
      "ariaLabel": "Formulaire de soumission de paiement",
      "bodyAfter": ".",
      "bodyBefore": "Le formulaire détaillé (passerelle / montant / proof_file / notes) est en cours de développement dans la Task 47 de la même vague (Wave 15). Une fois le sibling commité, ce placeholder sera remplacé par",
      "closeAria": "Fermer",
      "closeButton": "Fermer",
      "remaining": "Il reste {{amount}} à payer.",
      "title": "Soumettre le paiement — {{number}}"
    },
    "statusBadge": {
      "DRAFT": "Brouillon",
      "OVERDUE": "En retard",
      "PAID": "Payée",
      "PARTIAL": "Partielle",
      "PENDING_APPROVAL": "En attente",
      "SENT": "Envoyée",
      "VOIDED": "Annulée"
    },
    "statusFilter": {
      "OVERDUE": "En retard",
      "PAID": "Payée",
      "PARTIAL": "Partiellement payée",
      "PENDING_APPROVAL": "En attente d'approbation",
      "SENT": "Envoyée",
      "all": "Tous"
    },
    "table": {
      "colActions": "Actions",
      "colAmount": "Montant",
      "colCycle": "Cycle",
      "colDue": "Échéance",
      "colInvoice": "N° facture",
      "colStatus": "Statut",
      "empty": "Aucune facture dans le scope actuel pour le moment.",
      "loading": "Chargement des factures…",
      "pay": "Payer",
      "pdf": "PDF",
      "retry": "Réessayer"
    }
  },
  "invoices": {
    "detail": {
      "ariaLabel": "Détail de la facture",
      "billingAddress": "Destinataire (adresse de facturation)",
      "close": "Fermer",
      "colDescription": "Description",
      "colLineTotal": "Total ligne",
      "colQty": "Qté",
      "colUnitPrice": "Prix unitaire",
      "downloadPdf": "Télécharger le PDF",
      "downloadingPdf": "Téléchargement…",
      "errorPrefix": "Échec du chargement du détail : {{message}}",
      "grandTotal": "Total",
      "issuedAt": "Émise le {{date}}",
      "legalEntity": "Émetteur (entité juridique)",
      "lineItems": "Lignes de facturation",
      "loading": "Chargement du détail de la facture…",
      "mst": "Numéro fiscal : {{value}}",
      "noLines": "Aucune ligne.",
      "period": "Période de facturation",
      "retry": "Réessayer",
      "subtotal": "Sous-total",
      "taxId": "Numéro fiscal : {{value}}",
      "titleFallback": "Détail de la facture",
      "totals": "Totaux"
    },
    "filters": {
      "dateFrom": "Date de début",
      "dateTo": "Date de fin",
      "sort": "Trier",
      "sortOptions": {
        "newest": "Plus récentes",
        "oldest": "Plus anciennes",
        "totalAsc": "Total (croissant)"
      },
      "status": "Statut",
      "statusAll": "Tous"
    },
    "list": {
      "empty": "Aucune facture pour le moment — les factures sont émises automatiquement par le cron de la phase 4.1 (cycle mensuel).",
      "errorPrefix": "Échec du chargement des données : {{message}}",
      "loading": "Chargement des factures…",
      "retry": "Réessayer"
    },
    "page": {
      "description": "Liste des factures par période. Téléchargez le PDF pour l'impression / l'archivage. Les factures sont émises automatiquement par le cron de la phase 4.1.",
      "title": "Factures"
    },
    "pagination": {
      "next": "Suivant",
      "prev": "Précédent",
      "showing": "Affichage de {{from}}–{{to}} sur {{total}} factures · Page {{page}} / {{totalPages}}"
    },
    "status": {
      "cancelled": "Annulée",
      "draft": "Brouillon",
      "issued": "Émise",
      "paid": "Payée"
    },
    "table": {
      "actions": "Actions",
      "issuedAt": "Date d'émission",
      "loadingPdf": "Téléchargement…",
      "number": "N° de facture",
      "pdf": "PDF",
      "period": "Période",
      "status": "Statut",
      "total": "Total",
      "view": "Voir"
    },
    "toast": {
      "pdfFailedTitle": "Échec du téléchargement du PDF",
      "pdfPendingDesc": "Le système génère le PDF de cette facture. Veuillez réessayer dans environ 30 secondes.",
      "pdfPendingTitle": "Le PDF est en cours de génération",
      "pdfServerError": "Erreur du serveur (HTTP {{status}})."
    }
  },
  "limitRequestHistory": {
    "cancel": "Annuler",
    "cancelToast": {
      "errorTitle": "Impossible d'annuler la demande",
      "successDescription": "La demande est passée au statut Annulée.",
      "successTitle": "Demande annulée"
    },
    "columns": {
      "actions": "Actions",
      "amount": "Montant",
      "reason": "Motif",
      "requestedAt": "Demandé le",
      "reviewNote": "Note d'examen",
      "reviewedAt": "Examiné le",
      "status": "Statut"
    },
    "confirmCancel": {
      "confirmLabel": "Annuler la demande",
      "description": "Cette action est irréversible. Vous pourrez créer une nouvelle demande après l'annulation.",
      "title": "Annuler la demande {{amount}} ?"
    },
    "createFirst": "Créer votre première demande",
    "empty": "Aucune demande pour le moment.",
    "heading": "Historique des demandes de limite",
    "loadError": "Échec du chargement de l'historique : {{message}}",
    "loadMore": "Charger plus",
    "loading": "Chargement de l'historique des demandes…",
    "requestMore": "Demander plus",
    "retry": "Réessayer",
    "status": {
      "approved": "Approuvée",
      "cancelled": "Annulée",
      "expired": "Expirée",
      "pending": "En attente",
      "rejected": "Rejetée"
    },
    "subheading": "Les demandes les plus récentes en haut. Les demandes en attente peuvent être annulées."
  },
  "limitRequestModal": {
    "actions": {
      "cancel": "Annuler",
      "submit": "Envoyer la demande",
      "submitting": "Envoi…"
    },
    "amount": {
      "hint": "Minimum 1,00 $ — saisir en USD.",
      "label": "Montant à augmenter (USD)"
    },
    "duration": {
      "error": "La durée doit être comprise entre 1 et 365 jours.",
      "label": "Durée d'application (jours, 1–365)"
    },
    "durationPreset": "{{days}}d",
    "errors": {
      "invalidAmount": "Montant invalide — minimum 1,00 $.",
      "invalidPayload": "Charge utile invalide",
      "payloadField": "payload",
      "pendingExists": "Vous avez déjà une demande en attente — annulez d'abord l'ancienne (voir la section Historique ci-dessous).",
      "submitFallback": "Échec de l'envoi de la demande."
    },
    "reason": {
      "error": "La description doit comporter au moins {{min}} caractères, au plus {{max}}.",
      "hint": "Expliquez brièvement pourquoi vous avez besoin d'une limite plus élevée.",
      "label": "Motif (minimum {{min}} caractères)",
      "placeholder": "Ex. : Besoin de budget pour la campagne du Têt — approuvé par le responsable via Slack."
    },
    "title": "Demander une augmentation de la limite de dépenses",
    "toast": {
      "error": {
        "title": "Échec de l'envoi de la demande"
      },
      "pending": {
        "description": "Annulez d'abord l'ancienne demande (voir la section Historique ci-dessous).",
        "title": "Vous avez déjà une demande en attente"
      },
      "success": {
        "description": "Le Team Lead l'examinera dès que possible.",
        "title": "Demande envoyée"
      }
    }
  },
  "memberBilling": {
    "cards": {
      "remaining": {
        "label": "Restant"
      },
      "total": {
        "label": "Plafond total",
        "noLimit": "Aucun plafond accordé",
        "periodSubLabel": "Période : {{period}}"
      },
      "usagePct": {
        "label": "% utilisé"
      },
      "used": {
        "label": "Utilisé"
      }
    },
    "emptyBanner": {
      "cta": "Demander plus",
      "description": "Demandez une augmentation du plafond pour continuer à payer les commandes.",
      "title": "Vous avez épuisé le plafond de cette période"
    },
    "error": {
      "message": "Échec du chargement du plafond : {{message}}",
      "retry": "Réessayer"
    },
    "header": {
      "description": "Suivez le plafond alloué, le montant dépensé et demandez une augmentation au besoin.",
      "title": "Plafond et dépenses"
    },
    "loading": "Chargement du plafond…",
    "overview": {
      "requestMore": "Demander un plafond supplémentaire",
      "title": "Aperçu de la période"
    },
    "period": {
      "biweekly": "Bimensuel",
      "daily": "Quotidien",
      "monthly": "Mensuel",
      "quarter": "Trimestriel",
      "weekly": "Hebdomadaire"
    },
    "periodTabs": {
      "ariaLabel": "Sélectionner la période du plafond"
    },
    "transactions": {
      "placeholder": "Disponible une fois que la Phase 3.5 aura terminé le grand livre côté membre.",
      "title": "Historique des transactions"
    }
  },
  "merchantPay": {
    "actions": {
      "cancel": "Annuler",
      "submit": "Soumettre le paiement",
      "submitting": "Envoi en cours…",
      "uploading": "Téléversement de la preuve…"
    },
    "amount": {
      "hint": "Montant total : {{amount}} · Paiement partiel autorisé : oui",
      "label": "Montant (USD)"
    },
    "errors": {
      "amountExceedsFallback": "Le montant dépasse le solde restant.",
      "amountInvalidDecimals": "Le montant doit être une valeur USD positive avec 2 décimales max.",
      "gatewayNotEnabled": "La passerelle sélectionnée n'est pas activée pour cette entité.",
      "proofRequired": "Preuve requise",
      "referenceAlreadyUsed": "Référence déjà utilisée",
      "submitFailedHttp": "Échec de la soumission (HTTP {{status}}).",
      "submitFailedTitle": "Échec de la soumission",
      "unexpected": "Erreur inattendue."
    },
    "file": {
      "mimeReject": "PDF, PNG, JPG uniquement.",
      "sizeReject": "Max 5 Mo."
    },
    "gateway": {
      "label": "Passerelle de paiement",
      "placeholder": "Sélectionner une passerelle…"
    },
    "idempotencyNotice": "Cette action soumet une preuve de paiement pour examen comptable. Une double soumission dans les 30 s sera dédupliquée par la clé Idempotency-Key.",
    "noMethods": "Aucune passerelle de paiement n'est activée pour cette entité juridique. Contactez le support pour en configurer une avant de soumettre le paiement.",
    "notes": {
      "label": "Notes (facultatif)",
      "placeholder": "Virement bancaire exécuté par la comptabilité — veuillez vérifier"
    },
    "proof": {
      "browse": "parcourir",
      "constraints": "Max 5 Mo · PDF, PNG, JPG uniquement",
      "dropInstruction": "Déposez le reçu bancaire PDF/PNG ici, ou",
      "label": "Preuve de paiement",
      "replace": "Remplacer le fichier"
    },
    "reference": {
      "placeholder": "WIRE-OUT-20260430-MRCH-7"
    },
    "referenceLabel": {
      "airwallex": "ID de transaction Airwallex",
      "bank": "Référence SWIFT",
      "default": "Référence de paiement",
      "lianlian": "ID de virement LianLian",
      "payoneer": "ID de transaction Payoneer",
      "paypal": "ID de transaction PayPal",
      "pingpong": "ID de virement PingPong",
      "stripe": "ID de transaction Stripe",
      "sunrate": "ID de virement SunRate",
      "worldfirst": "ID de virement WorldFirst"
    },
    "subtitle": "Payer la facture {{invoiceNumber}} — {{amount}}",
    "success": {
      "description": "En attente de validation comptable — la facture est maintenant En attente d'approbation.",
      "title": "Paiement soumis"
    },
    "title": "Soumettre le paiement",
    "upload": {
      "failed": "Échec du téléversement de la preuve.",
      "failedHttp": "Échec du téléversement (HTTP {{status}})",
      "networkError": "Erreur réseau lors du téléversement.",
      "noUrl": "Le service de téléversement n'a retourné aucune URL — veuillez réessayer ou contacter le support."
    },
    "validation": {
      "amountExceeds": "Le montant dépasse le solde restant ({{amount}}).",
      "amountInvalid": "Le montant doit être une valeur USD positive (2 décimales max).",
      "gatewayRequired": "Sélectionnez une passerelle de paiement.",
      "notesTooLong": "Notes ≤ 500 caractères.",
      "proofRequired": "Preuve requise",
      "referenceRequired": "Référence requise.",
      "referenceTooLong": "Référence ≤ 120 caractères."
    }
  },
  "outstandingWidget": {
    "aria": {
      "due": "échéance {{date}}",
      "outstanding": "Impayé {{amount}}"
    },
    "due": {
      "label": "Échéance {{date}}"
    },
    "relativeDays": {
      "inDays": "dans {{count}} jours",
      "overdueDays": "en retard de {{count}} jours",
      "overdueOneDay": "en retard de 1 jour",
      "today": "aujourd'hui",
      "tomorrow": "demain"
    }
  },
  "overdueBanner": {
    "dismissAria": "Fermer la notification",
    "many": {
      "after": "). Veuillez payer pour continuer à passer des commandes.",
      "before": "Vous avez ",
      "middle": " factures en retard (la plus ancienne arrive à échéance le "
    },
    "one": {
      "after": "). Veuillez payer pour continuer à passer des commandes.",
      "before": "Vous avez 1 facture en retard (échéance le "
    },
    "viewInvoices": "Voir les factures"
  },
  "payCredit": {
    "actions": {
      "cancel": "Annuler",
      "submit": "Confirmer le paiement",
      "submitting": "Traitement…"
    },
    "amountHint": "Minimum 1,00 $ — maximum {{max}}.",
    "amountLabel": "Montant ($)",
    "currentDebt": "Dette actuelle",
    "errors": {
      "invalidAmount": "Montant invalide.",
      "overdueLocked": "Le crédit est verrouillé pour cause de retard — dette {{debt}} (échéance {{dueDate}}). Contactez l'administrateur pour déverrouiller.",
      "unknown": "Erreur inconnue.",
      "walletInsufficient": "Portefeuille insuffisant — le solde a changé. Veuillez recharger la page et réessayer."
    },
    "insufficientNotice": "Portefeuille insuffisant — vous pouvez payer au maximum",
    "payFull": "Tout payer",
    "title": "Rembourser le crédit",
    "toast": {
      "successDescription": "Payé {{amount}} — votre nouveau solde a été mis à jour.",
      "successTitle": "Crédit remboursé"
    },
    "topupCta": "Ajouter des fonds",
    "walletBalance": "Solde du portefeuille"
  },
  "paymentRequests": {
    "create": {
      "amount": "Montant",
      "ariaLabel": "Créer une demande de paiement",
      "cancel": "Annuler",
      "charCount": "{{count}}/{{max}} caractères",
      "description": "Demandez un remboursement ou un crédit hors plateforme auprès de Printway. Les admins l'examineront sous 1 à 2 jours ouvrés.",
      "purpose": "Motif",
      "purposePlaceholder": "Décrivez en détail le motif de votre demande (min 10 caractères, max 500)…",
      "submit": "Créer une demande",
      "submitting": "Envoi…",
      "title": "Créer une nouvelle demande de paiement"
    },
    "createButton": "+ Créer une demande",
    "detail": {
      "adminDecided": "Traitée par l'admin — {{status}}",
      "amount": "Montant",
      "ariaLabel": "Détail de la demande de paiement",
      "awaitingAdmin": "En attente de traitement par l'admin…",
      "close": "Fermer",
      "createdAt": "Créée le {{date}}",
      "history": "Historique des statuts",
      "purpose": "Motif",
      "submitted": "Demande envoyée"
    },
    "filters": {
      "sort": "Trier",
      "sortOptions": {
        "newest": "Plus récentes",
        "oldest": "Plus anciennes",
        "status": "Par statut"
      },
      "status": "Statut",
      "statusAll": "Tous"
    },
    "list": {
      "empty": "Aucune demande de paiement pour le moment — cliquez sur + Créer une demande pour commencer.",
      "errorPrefix": "Échec du chargement des données : {{message}}",
      "loading": "Chargement des demandes de paiement…",
      "retry": "Réessayer"
    },
    "page": {
      "description": "Demandes de remboursement / crédit hors plateforme auprès de Printway. Les admins les traitent manuellement ou automatiquement (selon les règles).",
      "title": "Demandes de paiement"
    },
    "pagination": {
      "next": "Suivant",
      "prev": "Précédent",
      "showing": "Affichage de {{from}}–{{to}} sur {{total}} demandes · Page {{page}} / {{totalPages}}"
    },
    "status": {
      "approved": "Approuvée",
      "cancelled": "Annulée",
      "paid": "Payée",
      "pending": "En attente",
      "rejected": "Rejetée"
    },
    "table": {
      "actions": "Actions",
      "amount": "Montant",
      "decidedAt": "Date de traitement",
      "number": "N° de demande",
      "requestedAt": "Date de création",
      "status": "Statut",
      "view": "Voir"
    },
    "toast": {
      "amountInvalidDesc": "Veuillez saisir un nombre positif.",
      "amountInvalidTitle": "Montant invalide",
      "createFailedTitle": "Échec de la création de la demande",
      "createdDesc": "Numéro de demande : {{number}}",
      "createdTitle": "Demande créée",
      "purposeShortDesc": "Veuillez fournir des détails (au moins 10 caractères).",
      "purposeShortTitle": "Motif trop court"
    }
  },
  "receipts": {
    "deliveryStatus": {
      "failed": "Échoué",
      "pending": "En attente",
      "sent": "Envoyé",
      "skipped": "Ignoré"
    },
    "download": {
      "aria": "Télécharger le reçu {{receiptNumber}}",
      "button": "Télécharger",
      "failedFallback": "Impossible de télécharger {{receiptNumber}}.",
      "failedTitle": "Échec du téléchargement"
    },
    "errors": {
      "loadFailed": "Échec du chargement des reçus."
    },
    "filters": {
      "dateFrom": {
        "aria": "Filtrer les reçus émis à partir de cette date",
        "label": "Du"
      },
      "dateTo": {
        "aria": "Filtrer les reçus émis jusqu'à cette date incluse",
        "label": "Au"
      },
      "delivery": {
        "all": "Tous les envois",
        "aria": "Filtrer les reçus par statut d'envoi d'e-mail",
        "label": "Envoi"
      },
      "direction": {
        "aria": "Sens de tri des reçus",
        "asc": "Croissant (le plus ancien / le plus petit d'abord)",
        "desc": "Décroissant (le plus récent / le plus grand d'abord)",
        "label": "Sens"
      },
      "sort": {
        "aria": "Champ de tri des reçus",
        "label": "Trier par"
      },
      "source": {
        "all": "Toutes les sources",
        "aria": "Filtrer les reçus par source de recharge",
        "label": "Source"
      }
    },
    "header": {
      "description": "Un reçu PDF par recharge réussie — automatique pour les passerelles instantanées (Niveau 1) et après approbation de l'administrateur pour les recharges manuelles (Niveau 2). Les reçus sont des documents fiscaux conservés pendant 7 ans.",
      "title": "Reçus de recharge"
    },
    "pagination": {
      "next": "Suivant",
      "nextAria": "Page suivante des reçus",
      "prev": "Précédent",
      "prevAria": "Page précédente des reçus",
      "summary": "Page {{page}} sur {{totalPages}} — {{total}} reçus"
    },
    "sortField": {
      "amount": "Montant",
      "issued_at": "Date d'émission",
      "receipt_number": "Numéro de reçu"
    },
    "sourceType": {
      "TOPUP_TIER1": "Niveau 1 (Auto)",
      "TOPUP_TIER2": "Niveau 2 (Manuel)"
    },
    "states": {
      "emptyBody": "Les reçus apparaissent ici après une recharge réussie. Essayez d'élargir les filtres ci-dessus.",
      "emptyTitle": "Aucun reçu pour le moment",
      "loading": "Chargement des reçus…"
    },
    "table": {
      "action": "Action",
      "amount": "Montant",
      "delivery": "Envoi",
      "issued": "Émis",
      "receiptNumber": "Reçu n°",
      "source": "Source"
    }
  },
  "settingsTabs": {
    "alertHistory": {
      "allChannels": "Tous les canaux",
      "allStatuses": "Tous les statuts",
      "firstPageAria": "Première page",
      "lastPageAria": "Dernière page",
      "nextPageAria": "Page suivante",
      "prevPageAria": "Page précédente"
    },
    "alerts": {
      "channelEmail": "Notifications par e-mail",
      "channelPush": "Notifications push",
      "thresholdSliderAria": "Curseur du seuil d'alerte",
      "title": "Alertes de solde faible",
      "subtitle": "Soyez averti lorsque le solde de votre portefeuille passe sous un seuil",
      "thresholdLabel": "Seuil d’alerte",
      "thresholdHelp": "Vous serez averti lorsque votre solde passe sous ce montant",
      "thresholdPlaceholder": "50",
      "channelsLegend": "Canaux de notification",
      "channelsHelp": "Choisissez comment recevoir les alertes",
      "channelInApp": "Notifications dans l’application (toujours activées)",
      "emailRecipientsLabel": "Destinataires e-mail (séparés par des virgules, max 10)",
      "emailRecipientsPlaceholder": "owner@example.com, finance@example.com",
      "smsRecipientsLabel": "Destinataires SMS (E.164, max 5)",
      "smsRecipientsPlaceholder": "+1415..., +84...",
      "cooldownLabel": "Délai (heures, 1-168)",
      "testTitle": "Alerte de test",
      "testHelp": "Envoyez une alerte de test pour vérifier que vos paramètres fonctionnent",
      "sendTest": "Envoyer une alerte de test",
      "savedDesc": "Paramètres d’alerte mis à jour.",
      "errThreshold": "Le seuil doit être un nombre non négatif.",
      "errEmailInvalid": "Adresse e-mail invalide : {{value}}",
      "errEmailMax": "Maximum 10 destinataires e-mail autorisés.",
      "errSmsInvalid": "Numéro E.164 invalide : {{value}}",
      "errSmsMax": "Maximum 5 destinataires SMS autorisés.",
      "errCooldown": "Le délai doit être compris entre 1 et 168 heures.",
      "testDispatchedTitle": "Alerte de test envoyée",
      "testDispatchedDesc": "{{ok}}/{{total}} canal(aux) en file d’attente pour livraison.",
      "rateLimitTitle": "Limite de fréquence atteinte",
      "noChannelsTitle": "Aucun canal configuré",
      "testFailedTitle": "Échec de l’alerte de test",
      "clientRateLimit": "Veuillez patienter un instant avant d’envoyer une autre alerte de test."
    },
    "autoTopup": {
      "pmPlaceholder": "UUID du mode de paiement",
      "title": "Recharge auto",
      "subtitle": "Rechargez automatiquement votre portefeuille lorsque le solde passe sous un seuil de déclenchement.",
      "triggerLabel": "Seuil de déclenchement (recharger quand le solde passe en dessous)",
      "triggerPlaceholder": "50.00",
      "amountLabel": "Montant de recharge (débité à chaque fois)",
      "amountPlaceholder": "500.00",
      "dailyLabel": "Limite quotidienne (optionnel)",
      "dailyPlaceholder": "1000.00",
      "monthlyLabel": "Limite mensuelle (optionnel)",
      "monthlyPlaceholder": "5000.00",
      "pmLabel": "Moyen de paiement (compte lié)",
      "pmSelectEmpty": "— Sélectionnez un moyen de paiement vérifié —",
      "pmUnverified": "(non vérifié)",
      "pmManageHelp": "Gérez les comptes liés sur {{path}}.",
      "errTrigger": "Le seuil de déclenchement doit être un nombre non négatif.",
      "errAmountPositive": "Le montant de recharge doit être supérieur à 0.",
      "errAmountDaily": "Le montant de recharge doit être ≤ à la limite quotidienne.",
      "errDailyMonthly": "La limite quotidienne doit être ≤ à la limite mensuelle.",
      "errPmRequired": "Choisissez un moyen de paiement pour activer la recharge auto.",
      "errLimitExceeded": "Le montant de recharge dépasse la limite quotidienne configurée.",
      "errPmNotVerified": "Le moyen de paiement doit être vérifié avant d’activer la recharge auto.",
      "errPmNotFound": "Moyen de paiement introuvable.",
      "concurrentTitle": "Modification concurrente détectée",
      "concurrentDesc": "Les paramètres ont été modifiés ailleurs. Rechargement des dernières valeurs…",
      "savedDesc": "Paramètres de recharge auto mis à jour."
    },
    "nav": {
      "breadcrumbAria": "Fil d'Ariane",
      "sectionsAria": "Sections des paramètres de facturation",
      "crumbBilling": "Facturation",
      "crumbSettings": "Paramètres"
    },
    "taxDocs": {
      "filterByYearAria": "Filtrer les documents fiscaux par année"
    },
    "page": {
      "title": "Paramètres de facturation",
      "subtitle": "Configurez les alertes de portefeuille, la recharge automatique et les préférences de notification"
    },
    "loading": "Chargement…",
    "tabs": {
      "alerts": "Alertes",
      "autoTopup": "Recharge auto",
      "history": "Historique des alertes",
      "receipts": "Reçus",
      "tax": "Documents fiscaux"
    },
    "common": {
      "enabled": "Activé",
      "disabled": "Désactivé",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "sending": "Envoi…",
      "savedTitle": "Enregistré",
      "saveFailedTitle": "Échec de l’enregistrement",
      "networkError": "Erreur réseau — vérifiez la connexion"
    }
  },
  "spendingChart": {
    "ariaLabel": "Graphique à barres empilées montrant les dépenses des {{window}} derniers jours",
    "empty": "Aucune donnée de dépense pour le moment.",
    "emptyWindow": "Aucune donnée de dépense sur les {{window}} derniers jours",
    "error": "Échec du chargement des transactions ({{message}}).",
    "footer": {
      "label": "Dépenses totales (sortie) sur {{window}} jours :"
    },
    "loading": "Chargement des données de dépenses…",
    "series": {
      "embroidery": "Broderie",
      "order": "Commande",
      "surcharge": "Surcharge",
      "topup": "Recharge",
      "withdraw": "Retrait"
    },
    "title": "Dépenses ({{window}} derniers jours)",
    "tooltip": {
      "total": "{{day}} — Total {{amount}}"
    },
    "unknownError": "inconnu"
  },
  "history": {
    "allChannels": "Tous les canaux",
    "allStatuses": "Tous les statuts",
    "from": "Du",
    "to": "Au",
    "channel": "Canal",
    "status": "Statut",
    "chanEmail": "E-mail",
    "chanSms": "SMS",
    "chanPush": "Push",
    "chanInapp": "Dans l'app",
    "statusSent": "Envoyé",
    "statusFailed": "Échoué",
    "statusBounced": "Rejeté",
    "statusPending": "En attente",
    "apply": "Appliquer les filtres",
    "reset": "Réinitialiser",
    "exportCsv": "Exporter en CSV",
    "exporting": "Exportation…",
    "colDate": "Date",
    "colChannel": "Canal",
    "colRecipient": "Destinataire",
    "colThreshold": "Seuil",
    "colBalance": "Solde",
    "colStatus": "Statut",
    "loading": "Chargement de l'historique des alertes…",
    "error": "Échec du chargement de l'historique des alertes.",
    "empty": "Aucune alerte dans la période sélectionnée.",
    "showing": "Affichage de {{start}}-{{end}} sur {{total}} enregistrements",
    "pageOf": "Page {{page}} sur {{total}}",
    "firstPageAria": "Première page",
    "prevPageAria": "Page précédente",
    "nextPageAria": "Page suivante",
    "lastPageAria": "Dernière page",
    "exportOkTitle": "Export prêt",
    "exportOkBody": "Le téléchargement de votre CSV démarre.",
    "exportFailTitle": "Échec de l'export",
    "exportFailBody": "Impossible d'exporter l'historique. Essayez de réduire les filtres."
  },
  "tax": {
    "filterByYearAria": "Filtrer les documents fiscaux par année",
    "title": "Lots de documents fiscaux mensuels",
    "subtitle": "Téléchargez les lots fiscaux mensuels (CSV dans un ZIP) pour vos archives.",
    "year": "Année",
    "colPeriod": "Période",
    "colEntity": "Entité juridique",
    "colStatus": "Statut",
    "colFiles": "Fichiers",
    "colSize": "Taille",
    "colGenerated": "Généré",
    "colAction": "Action",
    "loading": "Chargement des documents fiscaux…",
    "error": "Échec du chargement des documents fiscaux.",
    "emptyTitle": "Aucun document fiscal pour le moment",
    "emptyBody": "Les lots fiscaux mensuels de {{year}} apparaîtront ici une fois générés.",
    "download": "Télécharger",
    "preparing": "Préparation…",
    "statusReady": "Prêt",
    "statusFailed": "Échoué",
    "statusGenerating": "En cours de génération",
    "statusPending": "En attente",
    "downloadAria": "Télécharger le lot fiscal pour {{period}}",
    "disclaimer": "Ces documents sont fournis à des fins de comptabilité et de déclaration fiscale. Printway ne fournit pas de conseils fiscaux. Veuillez consulter un conseiller fiscal qualifié dans votre juridiction.",
    "toastStartedTitle": "Téléchargement démarré",
    "toastStartedBody": "Lot {{period}} ({{size}})",
    "toastFailTitle": "Échec du téléchargement",
    "toastNotReadyTitle": "Lot en cours de génération",
    "toastFailBody": "Impossible de télécharger le lot {{period}} — réessayez plus tard."
  }
}
